import JSZip from 'jszip';
import { createGeoJSONExport } from './geojsonExport';
import { createKMLExport } from './kmlExport';
import { createGPXExport } from './gpxExport';

export const createZipExport = async (survey, options = {}) => {
  const zip = new JSZip();

  // Add survey data in multiple formats
  zip.file(`${survey.name}.geojson`, createGeoJSONExport(survey));
  zip.file(`${survey.name}.kml`, createKMLExport(survey));
  zip.file(`${survey.name}.gpx`, createGPXExport(survey));

  // Add survey metadata
  zip.file('metadata.json', JSON.stringify({
    name: survey.name,
    description: survey.description,
    customerName: survey.customerName,
    customerPO: survey.customerPO,
    createdAt: survey.createdAt,
    updatedAt: survey.updatedAt,
    status: survey.status,
    vehicle: survey.vehicle,
    poiCount: survey.pois?.length || 0,
    routeCount: survey.routes?.length || 0,
    exportDate: new Date().toISOString()
  }, null, 2));

  // Add POI photos if requested
  if (options.includePhotos && survey.pois?.length) {
    const photos = zip.folder('photos');
    
    const photoPromises = survey.pois.flatMap(poi => 
      poi.photos?.map(async photoUrl => {
        try {
          const response = await fetch(photoUrl);
          const blob = await response.blob();
          photos.file(`${poi.id}_${Date.now()}.jpg`, blob);
        } catch (error) {
          console.error(`Failed to add photo for POI ${poi.id}:`, error);
        }
      }) || []
    );

    await Promise.all(photoPromises);
  }

  return zip.generateAsync({ type: 'blob' });
};